module.exports = __webpack_public_path__ + "img/advisor-img3.3ac9f1ed.jpg";